import * as React from "react";
import {
    Avatar,
    Button,
    Card,
    CardActionArea,
    CardContent,
    CardHeader,
    CardMedia,
    Divider,
    IconButton,
    List,
    Menu,
    MenuItem,
    Tooltip,
    Typography,
} from "@material-ui/core";
import {SNSData, SNSDataList} from "../../util/api";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import RepeatIcon from "@material-ui/icons/Repeat";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import AddIcon from "@material-ui/icons/Add";
import moment from "moment";
import DesktopAccessDisabledIcon from "@material-ui/icons/DesktopAccessDisabled";
import {useState} from "react";

import styles from "./css/list.module.scss";
import {ShareOutlined} from "@material-ui/icons";

type ListProps = {
    lists: SNSDataList[];
    setOpenModal: (open: boolean) => void;
    setOpenAddAccount: (open: boolean) => void;
    setOpenDeleteList: (open: boolean) => void;
    setOpenAccountList: (open: boolean) => void;
    setSelectedList: (id: number) => void;
};

type CardProps = {
    content: SNSData;
};

const YoutubeCard: React.FC<CardProps> = (props: CardProps) => {
    const {content} = props;
    return (
        <>
            <Card className={styles.contentCard}>
                <a
                    href={content.originalUrl}
                    target="_blank"
                    className={styles.cardLink}
                    rel="noopener noreferrer"
                >
                    <CardActionArea>
                        <CardMedia
                            image={content.pictureUrl}
                            title={content.title}
                            className={styles.media}
                        />
                        <CardContent className={styles.content}>
                            <Typography
                                gutterBottom
                                variant="body1"
                                component="h5"
                                className={styles.contentTitle}
                            >
                                {content.title}
                            </Typography>
                            <div className={styles.ownerRow}>
                                <Avatar
                                    alt={content.owner}
                                    src={content.ownerIcon}
                                />
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    component="p"
                                    className={styles.youtubeOwnerName}
                                >
                                    {content.owner}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    component="p"
                                    className={styles.date}
                                >
                                    {moment(content.createdAt).fromNow()}
                                </Typography>
                            </div>
                        </CardContent>
                    </CardActionArea>
                </a>
            </Card>
        </>
    );
};

const TwitterCard: React.FC<CardProps> = (props: CardProps) => {
    const {content} = props;
    return (
        <>
            <Card className={styles.contentCard}>
                <a
                    href={content.originalUrl}
                    target="_blank"
                    className={styles.cardLink}
                    rel="noopener noreferrer"
                >
                    <CardActionArea>
                        <CardContent className={styles.content}>
                            <div className={styles.ownerRow}>
                                <Avatar
                                    alt={content.owner}
                                    src={content.ownerIcon}
                                />
                                <Typography
                                    gutterBottom
                                    variant="body2"
                                    component="h5"
                                    className={styles.twitterOwnerName}
                                >
                                    {content.owner}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    component="p"
                                    className={styles.date}
                                >
                                    {moment(content.createdAt).fromNow()}
                                </Typography>
                            </div>
                            <Typography
                                gutterBottom
                                variant="body1"
                                component="h5"
                                className={styles.contentTitle}
                            >
                                {content.content}
                            </Typography>
                            <div className={styles.twitterMetaRow}>
                                <div className={styles.twitterMetaSet}>
                                    <ChatBubbleOutlineIcon
                                        className={styles.twitterMetaIcon}
                                    />
                                    <div>{content.meta?.comment}</div>
                                </div>
                                <div className={styles.twitterMetaSet}>
                                    <RepeatIcon
                                        className={styles.twitterMetaIcon}
                                    />
                                    <div>{content.meta?.retweet}</div>
                                </div>
                                <div className={styles.twitterMetaSet}>
                                    <FavoriteBorderIcon
                                        className={styles.twitterMetaIcon}
                                    />
                                    <div>{content.meta?.like}</div>
                                </div>
                                <div className={styles.twitterMetaSet}>
                                    <ShareOutlined
                                        className={styles.twitterMetaIcon}
                                    />
                                </div>
                            </div>
                        </CardContent>
                    </CardActionArea>
                </a>
            </Card>
        </>
    );
};

export const ListComponent: React.FC<ListProps> = (props: ListProps) => {
    const {
        lists,
        setOpenAddAccount,
        setOpenDeleteList,
        setOpenAccountList,
        setSelectedList,
    } = props;
    let listKey: number = 1; // For map key
    let cardKey: number = 1; // For map key

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleListMenuClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleListMenuClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <div style={{overflowX: "scroll", backgroundColor: "#E3F3FF"}}>
                <div style={{display: "inline-block"}}>
                    <div style={{display: "flex"}}>
                        {lists && lists.length === 0 && (
                            <div className={styles.noList}>
                                <DesktopAccessDisabledIcon
                                    style={{
                                        width: "3rem",
                                        height: "3rem",
                                        marginBottom: "20px",
                                        color: "#2E3852",
                                    }}
                                />
                                表示するデータがありません
                                <br />
                                右上の＋ボタンからリストを追加しましょう
                            </div>
                        )}

                        {lists &&
                            lists.length > 0 &&
                            lists[0].id !== 0 &&
                            lists.map((list) => {
                                return (
                                    <Card
                                        className={styles.card}
                                        key={listKey++}
                                    >
                                        <CardHeader
                                            action={
                                                <>
                                                    <Tooltip title="リストにアカウントを追加">
                                                        <IconButton
                                                            className={
                                                                styles.iconButton
                                                            }
                                                            aria-label="addList"
                                                            onClick={() => {
                                                                setOpenAddAccount(
                                                                    true
                                                                );
                                                                setSelectedList(
                                                                    list.id
                                                                );
                                                            }}
                                                        >
                                                            <AddIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <IconButton
                                                        className={
                                                            styles.iconButton
                                                        }
                                                        aria-label="more"
                                                        aria-controls="long-menu"
                                                        aria-haspopup="true"
                                                        onClick={(e) => {
                                                            setSelectedList(
                                                                list.id
                                                            );
                                                            handleListMenuClick(
                                                                e
                                                            );
                                                        }}
                                                    >
                                                        <MoreVertIcon />
                                                    </IconButton>
                                                    <Menu
                                                        id={`listMenu-${list.id}`}
                                                        anchorEl={anchorEl}
                                                        keepMounted
                                                        open={open}
                                                        onClose={
                                                            handleListMenuClose
                                                        }
                                                        PaperProps={{
                                                            style: {
                                                                maxHeight:
                                                                    48 * 4.5,
                                                                width: "20ch",
                                                            },
                                                        }}
                                                    >
                                                        <MenuItem
                                                            onClick={() => {
                                                                handleListMenuClose();
                                                                setOpenAccountList(
                                                                    true
                                                                );
                                                            }}
                                                        >
                                                            アカウント一覧
                                                        </MenuItem>
                                                        <MenuItem
                                                            onClick={() => {
                                                                handleListMenuClose();
                                                                setOpenDeleteList(
                                                                    true
                                                                );
                                                            }}
                                                        >
                                                            削除
                                                        </MenuItem>
                                                    </Menu>
                                                </>
                                            }
                                            subheader={list.name}
                                            className={styles.listHeader}
                                            classes={{action: styles.action}}
                                        />
                                        <Divider />
                                        <List className={styles.list}>
                                            {list.snsData &&
                                            list.snsData.length > 0 ? (
                                                list.snsData.map(
                                                    (content: SNSData) => {
                                                        return (
                                                            <div
                                                                key={cardKey++}
                                                            >
                                                                {content.type ===
                                                                "twitter" ? (
                                                                    <TwitterCard
                                                                        content={
                                                                            content
                                                                        }
                                                                    />
                                                                ) : (
                                                                    <YoutubeCard
                                                                        content={
                                                                            content
                                                                        }
                                                                    />
                                                                )}
                                                                <Divider
                                                                    component="li"
                                                                    className={
                                                                        styles.divider
                                                                    }
                                                                />
                                                            </div>
                                                        );
                                                    }
                                                )
                                            ) : (
                                                <div
                                                    style={{
                                                        textAlign: "center",
                                                        marginTop: "30vh",
                                                        color: "#2E3852",
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        表示するデータがありません
                                                    </p>
                                                    <p
                                                        style={{
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        リストにアカウント/チャンネルを追加しましょう
                                                    </p>
                                                    <Button
                                                        onClick={() => {
                                                            setOpenAddAccount(
                                                                true
                                                            );
                                                            setSelectedList(
                                                                list.id
                                                            );
                                                        }}
                                                        className={
                                                            styles.addAccountButton
                                                        }
                                                    >
                                                        アカウントを追加する
                                                    </Button>
                                                </div>
                                            )}
                                        </List>
                                    </Card>
                                );
                            })}
                    </div>
                </div>
            </div>
        </>
    );
};
